import type { FC } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { numeralsFormatter, selectCouponPossibleOddsV2, selectCouponSelectedBetsV2, selectUserIsAuthenticated } from '@mwl/core-lib';
import { Button } from '@/components/Button/Button';
import { routes } from '@/constants';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import { selectCouponPreviewState, setShowMobileCoupon, setShowPreviewCoupon } from '@/store';
import styles from './CouponBetsCounter.module.scss';
const CouponBetsCounter: FC = () => {
  const router = useRouter();
  const dispatch = useTypedDispatch();
  const {
    t
  } = useTranslation('sport');
  const selectedBets = useTypedSelector(selectCouponSelectedBetsV2);
  const possibleOdds = useTypedSelector(selectCouponPossibleOddsV2);
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  const isShowPreviewCoupon = useTypedSelector(selectCouponPreviewState);
  const handleClick = async () => {
    if (router.pathname === routes.sport.history) {
      await router.push(routes.sport.home);
    }
    dispatch(setShowPreviewCoupon(false));
  };
  const handleEventsClick = () => {
    if (isAuth && isShowPreviewCoupon) {
      dispatch(setShowPreviewCoupon(false));
      dispatch(setShowMobileCoupon(true));
    }
  };
  if (isShowPreviewCoupon && !selectedBets.length) {
    return isAuth ? <Button as="button" onClick={handleClick} fullWidth variant="filled" color="white" size="lg" fontWeight="bold" align="center" fontSize="xl" className={styles.button} rounded>
        {t('coupon.select_event', 'Select event')}
      </Button> : null;
  }
  if (!selectedBets.length) {
    return null;
  }
  return <button type="button" className={styles.root} onClick={handleEventsClick} data-sentry-component="CouponBetsCounter" data-sentry-source-file="CouponBetsCounter.tsx">
      <span className={styles.text}>
        <span className={styles.betsCount}>{selectedBets.length}</span>
        <span>
          {numeralsFormatter(selectedBets.length, [t('coupon.events_1', 'event'), t('coupon.events_2', 'events'), t('coupon.events_3', 'events')])}
        </span>
      </span>

      <span className={styles.odds}>{possibleOdds}</span>
    </button>;
};
export { CouponBetsCounter };